export default __webpack_public_path__ + "static/media/gt.c2f133b4.svg";